module.exports = __webpack_public_path__ + "static/media/step-1.d1a8d81d.png";